import { useCurrentStoreProgram } from '@/features/account/services/RewardsPrograms/hooks'
import { formatPrice } from '@/features/shared/utils/formatter'
import { type ProductLoyaltyPrice } from '@/features/shop/services/Product/types'

type ProductForLoyaltyPricing = {
  pricing?: ProductLoyaltyPrice
  quantity: number
}

export const useLoyaltyPrice = (product: ProductForLoyaltyPricing) => {
  const loyaltyProgram = useCurrentStoreProgram()
  const hasLinkedRewardsAccount = !!loyaltyProgram?.identifier

  const loyaltyPrice = product.pricing?.loyalty.price ?? 0
  const quantity = product.quantity
  const formattedLoyaltyPrice = formatPrice(loyaltyPrice)
  const formattedTotalLoyaltyPrice = formatPrice(loyaltyPrice * quantity)
  const shouldShowLoyaltyPrice = hasLinkedRewardsAccount && !!loyaltyPrice

  return {
    loyaltyProgram,
    hasLinkedRewardsAccount,
    loyaltyPrice,
    formattedLoyaltyPrice,
    formattedTotalLoyaltyPrice,
    shouldShowLoyaltyPrice,
  }
}
